import { sorting } from '@/mixins'
import { storePagination } from '@/mixins/store'
import axios from '@axios'
import purchaseRequisitionMaintain from './purchase-requisition-maintain'

/**
 * Critérios de pesquisa comuns à listagem e ao relatório, para que a planilha traga
 * exatamente as requisições exibidas na tela.
 */
const getSearchParams = state => {
  const params = {
    id: state.filters.id,
    storeId: state.filters.storeId,
    skuId: state.filters.skuId,
    createdDateFrom: state.filters.createdDate.startDate,
    createdDateTo: state.filters.createdDate.endDate,
    sortBy: sorting.methods.getSorting(state),
  }

  // A API recebe uma lista de status. É omitido quando "Todos" está selecionado, pois
  // um valor vazio não é convertível para o enum.
  if (state.filters.status) {
    params.statusList = [state.filters.status]
  }

  return params
}

const getInitialState = () => ({
  ...storePagination.state(),
  purchaseRequisitions: [],
  filters: {
    id: null,
    storeId: null,
    skuId: null,
    status: null,
    createdDate: {
      startDate: null,
      endDate: null,
    },
  },
})

export default {
  namespaced: true,
  modules: { purchaseRequisitionMaintain },

  state: getInitialState(),

  getters: {},

  mutations: {
    ...storePagination.mutations,

    SET_PURCHASES_REQUISITIONS(state, purchaseRequisitions) {
      state.purchaseRequisitions = purchaseRequisitions
    },
    SET_FILTERS(state, filters) {
      state.filters = filters
    },
    CLEAN_STATE(state) {
      const { filters, paging, purchaseRequisitions } = getInitialState()
      state.filters = filters
      state.purchaseRequisitions = purchaseRequisitions
      state.paging = paging
    },
  },

  actions: {
    ...storePagination.actions,

    async fetchPurchaseRequisition({ commit, state }) {
      const { data } = await axios.get('/api/purchase-requisitions', {
        params: {
          ...getSearchParams(state),
          pageSize: state.paging.pageSize,
          pageIndex: state.paging.currentPage - 1,
        },
      })

      commit('SET_PURCHASES_REQUISITIONS', data.results)
      commit('SET_PAGING', {
        ...state.paging,
        rowCount: data.rowCount,
        rowsInCurrentPage: data.rowsInCurrentPage,
      })

      return data
    },

    /**
     * Planilha com um registro por produto de cada requisição que atende aos filtros.
     * Sem paginação: o relatório contempla todo o resultado da pesquisa.
     */
    async generateReport({ state }) {
      const { data } = await axios.get('/api/purchase-requisitions/download', {
        params: {
          ...getSearchParams(state),
          pageSize: 0,
          pageIndex: 0,
        },
        responseType: 'blob',
      })
      return data
    },

    resetFilters({ commit }) {
      commit('SET_CURRENT_PAGE', 1)
      commit('SET_FILTERS', getInitialState().filters)
    },

    cleanState({ commit }) {
      commit('CLEAN_STATE')
    },
  },
}
